import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen bg-gh-navy grid place-items-center text-white/60 text-sm">
        <div className="flex items-center gap-3">
          <span className="w-4 h-4 border-2 border-white/20 border-t-[#10B981] rounded-full animate-spin" />
          Checking your session…
        </div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
}
